import en from './en';
import pt from './pt';

const langData = {
	en: en,
	pt: pt
}

export default langData;